import { CATEGORY_LABELS, CATEGORY_ORDER, type Result } from "./searchTypes";
import { navigate } from "./router";

// SearchResults renders a flat Result[] grouped by category (spec §10:
// "Search results should be typed and grouped by content category"),
// shared by SearchPage (the full /search page) and CommandPalette (the
// ⌘K overlay) so both stay visually and behaviourally consistent.
export function SearchResults({ results, onNavigate }: { results: Result[]; onNavigate?: () => void }) {
  if (results.length === 0) {
    return <p className="muted-note">No results.</p>;
  }

  const byCategory = new Map<string, Result[]>();
  for (const r of results) {
    const list = byCategory.get(r.category) ?? [];
    list.push(r);
    byCategory.set(r.category, list);
  }

  return (
    <div className="search-results">
      {CATEGORY_ORDER.filter((cat) => byCategory.has(cat)).map((cat) => (
        <div className="search-category" key={cat}>
          <h3>{CATEGORY_LABELS[cat]}</h3>
          <ul className="search-result-list">
            {(byCategory.get(cat) ?? []).map((r) => (
              <li key={`${r.repo}:${r.category}:${r.id}`}>
                <a
                  href={r.url}
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigate?.();
                    navigate(r.url);
                  }}
                >
                  <span className="search-result-title">{r.title}</span>
                  <span className="search-result-snippet">{r.snippet}</span>
                  {r.snapshotDate && (
                    <span className="muted-note search-result-snapshot"> (frozen register snapshot, {r.snapshotDate})</span>
                  )}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
